import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import _defineProperty from "E:/workSpacke/screening-sys/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import { getToken } from "@/utils/auth";
import { getDemoDataList, updateDemoData } from "@/api/user";
export default {
  name: "Warning",
  computed: _objectSpread({}, mapGetters(["roles"])),
  data: function data() {
    return {
      warningTips: false,
      warningData: [],
      warningAudio: null
    };
  },
  methods: {
    //关闭预警提示
    closeWarningTips: function closeWarningTips() {
      var _this = this;
      this.warningTips = false;
      //停止推送提醒信息
      updateDemoData({
        token: getToken()
      }).then(function (res) {
        _this.loopTips();
        if (_this.roles[0] == "schooldoctor") {
          _this.$router.push('/school/functionally/earlyWarningProcessing');
        } else if (_this.roles[0] == "district") {
          _this.$router.push('/gov/functionally/earlyWarningProcessing');
        }
      });
    },
    //预警消息轮询
    loopTips: function loopTips() {
      var _this2 = this;
      this.warningData = [];
      //获取收到提醒信息
      getDemoDataList({
        token: getToken()
      }).then(function (res) {
        if (res.data.length == 0) {
          setTimeout(function () {
            _this2.loopTips();
          }, 5000);
        } else {
          _this2.warningData = res.data;
          _this2.warningTips = true;
          _this2.audioPlay();
        }
      });
    },
    //播放预警提示音
    audioPlay: function audioPlay() {
      var _this3 = this;
      this.warningAudio.src = require("@/assets/audio/yi_chang_xj.mp3");
      this.warningAudio.play();
      setTimeout(function () {
        _this3.warningAudio.src = require("@/assets/audio/nan_shen_yi_chang.mp3");
        _this3.warningAudio.play();
      }, 3000);
    }
  },
  created: function created() {
    //预警轮询
    // if (this.roles[0] == "district" || this.roles[0] == "schooldoctor") {
    //   this.loopTips();
    //   this.warningAudio = new Audio();
    // }
  }
};